'use client';

import React, { useMemo, useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { toast } from 'react-toastify';

import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import UndoIcon from '@mui/icons-material/Undo';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import getPORequestColumns from '../../utils/getPORequestColumns';
import useUserMap from '../../hooks/useUserMap';
import ConfirmDialog from '../UserDialog/ConfirmDialog';
import axios from 'axios';

import {
  ClientSideRowModelModule,
  ClipboardModule,
  ExcelExportModule,
  ColumnMenuModule,
  ContextMenuModule,
  CellSelectionModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  RowStyleModule,
  RowSelectionModule,
  SetFilterModule,
  MultiFilterModule,
  GroupFilterModule,
  PaginationModule,
  ModuleRegistry,
} from 'ag-grid-enterprise';

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  ClipboardModule,
  ExcelExportModule,
  ColumnMenuModule,
  ContextMenuModule,
  CellSelectionModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  RowStyleModule,
  RowSelectionModule,
  SetFilterModule,
  MultiFilterModule,
  GroupFilterModule,
  PaginationModule,
]);

const ArchivedRequests = ({ data, refetch }) => {
  const [rowData, setRowData] = useState([]);
  const userMap = useUserMap();
  const [confirmDialog, setConfirmDialog] = useState({ open: false });

  useEffect(() => {
    setRowData(data || []);
  }, [data]);

  const actionsRenderer = (params) => (
    <Box display="flex" alignItems="center" justifyContent="center" height="100%" gap={1}>
      <Tooltip title="Reinstate Request">
        <IconButton size="small" color="primary" onClick={() => handleReinstate(params.data)}>
          <UndoIcon fontSize="medium" />
        </IconButton>
      </Tooltip>

      <Tooltip title="Delete Permanently">
        <IconButton size="small" color="error" onClick={() => handleDeleteRfq(params.data)}>
          <LocalFireDepartmentIcon fontSize="medium" />
        </IconButton>
      </Tooltip>
    </Box>
  );

  const closeConfirmDialog = () => {
    setConfirmDialog({ open: false });
  };

  const handleDeleteRfq = async (rfqRow) => {
    setConfirmDialog({
      open: true,
      message: `Are you sure you want to delete "${rfqRow.name}"? - THIS WILL BE A HARD DELETE IN FUTURE. NOT CURRENTLY IMPLEMENTED`,
      onConfirm: async () => {
        try {
          ////////HARD DELETE TO BE MADE FUNCTIONAL IN FUTURE
          //   const response = await axios.put(`/api/RfqHeader/rfq-isdelete`, {
          //     id: rfqRow.id,
          //     isDeleted: true,
          //   });
          //   if (response.status === 200) {
          //     toast.success('Request deleted successfully');
          //     await refetch();
          //   } else {
          //     toast.error('Error deleting the request');
          //   }
        } catch {
          console.error(err);
          if (err.response?.status === 403) {
            toast.error('Elevated permissions required for this action.');
          } else {
            toast.error('Delete failed');
          }
        } finally {
          closeConfirmDialog();
        }
      },
      onCancel: closeConfirmDialog,
    });
  };

  const handleReinstate = (rfqRow) => {
    setConfirmDialog({
      open: true,
      message: `Are you sure you want to reinstate "${rfqRow.name}"?`,
      onConfirm: async () => {
        try {
          await axios.put(`/api/RfqHeader/rfq-isdelete`, {
            id: rfqRow.id,
            isDeleted: false,
          });

          toast.success('Request reinstated successfully');
          await refetch();
        } catch {
          console.error(err);
          if (err.response?.status === 403) {
            toast.error('Elevated permissions required for this action.');
          } else {
            toast.error('Reinstate failed');
          }
        } finally {
          closeConfirmDialog();
        }
      },
      onCancel: closeConfirmDialog,
    });
  };

  const columnDefs = useMemo(() => getPORequestColumns(userMap, actionsRenderer), [userMap]);

  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    cellStyle: {
      textAlign: 'left',
    },
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '80vh',
        padding: 2,
      }}
    >
      <Box sx={{ flexGrow: 1, minHeight: 0 }}>
        <div style={{ height: '100%', width: '100%' }}>
          <AgGridReact columnDefs={columnDefs} defaultColDef={defaultColDef} rowData={rowData} pagination={true} />
        </div>
      </Box>

      <ConfirmDialog
        open={confirmDialog.open}
        message={confirmDialog.message}
        onConfirm={confirmDialog.onConfirm}
        onCancel={confirmDialog.onCancel}
        onClose={closeConfirmDialog}
      />
    </Box>
  );
};

export default ArchivedRequests;
